import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from '@i18n';
import {
  Table,
  withLayout,
  TableBottom,
  Section,
  useFirstRender,
} from '@casanova/casanova-common';
import { columns } from './columns';

function VehicleStatus({
  match,
  vehicleStatus,
  fetchVehicleStatus,
  setPageVehicleStatus,
  onlyFetchParams = false,
}) {
  const { params = {}, results = {} } = vehicleStatus;

  const isFirstRender = useFirstRender();

  const vehicleUuid = useMemo(() => match.params.id, [match.params.id]);

  useEffect(() => {
    console.log('--- Debugging useEffect fetchVehicleStatus ---');
    console.log('vehicleUuid:', vehicleUuid);
    console.log('params:', params);
    console.log('onlyFetchParams:', onlyFetchParams);
    console.log('isFirstRender:', isFirstRender);
    console.log('Condition:', onlyFetchParams ? !isFirstRender : true);
    if (onlyFetchParams ? !isFirstRender : true) {
      console.log('call fetchVehicleStatus');
      fetchVehicleStatus({ params, uuid: vehicleUuid });
    }
  }, [vehicleUuid, params, onlyFetchParams]);

  return (
    <Section title={i18n('VEHICLES__SECTIONS__VEHICLE_ESTATUS__TITLE')}>
      <Table
        primary
        emptyMessage={i18n('ERROR__COMMONS__NOT_FOUND')}
        dataList={results.list}
        columns={columns}
      />
      <TableBottom
        search={vehicleStatus}
        onChange={setPageVehicleStatus}
        showButton={false}
      />
    </Section>
  );
}

VehicleStatus.propTypes = {
  onlyFetchParams: PropTypes.bool,
};

export default withLayout(VehicleStatus, { withLoader: false });
